import { render } from "./course-index.vue?vue&type=template&id=5d591420"
import script from "./course-index.vue?vue&type=script&lang=js"
export * from "./course-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__